import { Ribbon } from "@tredespace/ui/widgets";
import type { JSX } from "react";
import { BuildSection } from "./ribbon/BuildSection.tsx";
import { ModelSection } from "./ribbon/ModelSection.tsx";
import { OptionsSection } from "./ribbon/OptionsSection.tsx";
import { ViewSection } from "./ribbon/ViewSection.tsx";

/** The workbench toolbar; lives in the locked, tab-less top dock node. */
export function RibbonBar(): JSX.Element {
  return (
    <Ribbon>
      <BuildSection />
      <OptionsSection />
      <ModelSection />
      <ViewSection />
    </Ribbon>
  );
}
